<template>
  <div id="pricing">
    <h2
      class="display-1 my-md-3 my-lg-3 my-xl-3 pb-5 font-weight-bold"
    >Elige el plan para tu establecimiento</h2>
    <div>
      Y
      <a href="https://admin.merlocode.com/signup" class="primary--text">pruébalo gratis</a>
      durante 15 días.
    </div>

    <v-row
      no-gutters
      class="flex-column flex-md-row flex-lg-row flex-xl-row justify-lg-space-between justify-md-space-between"
    >
      <v-col md="6" lg="6" xl="6" class="mb-xs-4 mb-sm-4 mb-md-0 mb-lg-0 mb-xl-0">
        <v-card outlined class="primary-border my-8 mr-md-8 mr-lg-8 mr-xl-8 max-height">
          <v-card-title>Plan Basic</v-card-title>
          <v-card-text class="mb-12">
            Gestión de carta digital sin límites con hasta 50 QRs asociados y
            carta digital con llamada al camarero desde dispositivo móvil.
          </v-card-text>
          <v-card-actions class="d-flex flex-wrap d-block" style="position: absolute;bottom: 0;">
            <v-btn text href="https://admin.merlocode.com/signup" class>20€/mes*</v-btn>
            <v-btn text href="https://admin.merlocode.com/signup" class>200€/año*</v-btn>
            <v-card-subtitle class="caption">*IVA no incluido</v-card-subtitle>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="6" lg="6" xl="6" class="mb-xs-4 mb-sm-4 mb-md-0 mb-lg-0 mb-xl-0">
        <v-card outlined class="primary-border my-8 mr-md-8 mr-lg-8 mr-xl-8 max-height">
          <v-card-title>Plan Standard</v-card-title>
          <v-card-text class="mb-12">
            Gestión de carta digital sin límites con hasta 100 QRs asociados y
            carta digital con llamada al camarero desde dispositivo móvil
            realizar pedidos desde el dispositivo móvil y gestión de pedidos
            desde diferentes dispositivos.
          </v-card-text>
          <v-card-actions style="position: absolute; bottom: 0;">
            <v-btn text href="https://admin.merlocode.com/signup">30€/mes*</v-btn>
            <v-btn text href="https://admin.merlocode.com/signup">300€/año*</v-btn>
            <v-card-subtitle class="caption">*IVA no incluido</v-card-subtitle>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-container class="my-12">
      <v-col class="text-center my-12">
        <h2 class="headline font-weight-bold my-4">¿No te encajan nuestros planes?</h2>
        <div class="title">
          <span @click="$vuetify.goTo('#contactUs')" class="primary--text">Contáctanos</span>
          para grandes volúmenes o soluciones White Label.
        </div>
      </v-col>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>
